import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleSnackBar, invokePostService, generateLlmComponents, setReRender, showAcceptRejectButtons } from "../../../store/global/actions";
import Tooltip from '@material-ui/core/Tooltip';
import { Grid, IconButton } from "@material-ui/core";
import { Close, Check } from "@material-ui/icons";
import { rfNodesToNode } from "../../../services/reactFlowService";
import { getLlmModel, getLlmQuery } from "../../../store/global/selectors";

function ModelDecider({rfNodes, rfEdges}) {

    console.log("rfNodes-----------", rfNodes)

    const dispatch = useDispatch();
    const llmQuery = useSelector(getLlmQuery)
    const llmModel = useSelector(getLlmModel)

    

    const handleAcceptModel  = async () => {
        dispatch(invokePostService('createLlmModel', { clusterlets : rfNodesToNode(rfNodes), connections : rfEdges, llmData:{ blueprint_name: "", initial_prompt:llmQuery ? llmQuery  : "", accepted_model:llmModel ?  llmModel : [], final_model:llmModel ?  llmModel : [] } }, []))
        .then((savedData) => {
            if (savedData.status) {
                dispatch(setReRender())
                dispatch(showAcceptRejectButtons(false))
                dispatch(handleSnackBar({ open: true, message: `Acepted the generated model`, severity: "success" }));
            } else {                
                
            }
        })
        .catch(error => console.error(error));        
    }
    
    const handleRejectModel  = async () => {
        dispatch(showAcceptRejectButtons(false))
        dispatch(setReRender());
    }

    return (
        <Grid
            container
            spacing={2}
            style={{
                position: "absolute",
                top: "100px",
                right: "40px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "8px",
                zIndex: 3000,
            }}
        >
            <Tooltip title="Reject the model" arrow>
                <IconButton style={{ background: "#ccc", borderRadius: "8px" }} onClick={handleRejectModel}>
                    <Close />
                </IconButton>
            </Tooltip>

            <Tooltip title="Accept the model" arrow>
                <IconButton style={{ backgroundColor: "#48566a", color: "white", borderRadius: "8px" }} onClick={handleAcceptModel}>
                    <Check />
                </IconButton>
            </Tooltip>
        </Grid>
    );
}

export default ModelDecider;